import { EvidenceCardConfig } from "@risalabs_frontend_org/oasis-ui-kit";

export type Answer = string | string[] | null;

export interface UserFeedback {
  selected_option: string;
  comment: string;
  created_at: string;
  created_by: string;
}

export interface Choice {
  name: string;
  text: string;
  next_question: string | null;
  /** Opaque rule id, e.g. "297636_215190". null when not part of a rule group. */
  condition_groups: string | null;
  /** Flag indicating whether this choice accepts a free-text follow-up: "NA" | "M" | null. */
  additional_free_text: string | null;
  /** Populated only when the user typed a free-text answer alongside this choice. */
  additional_free_text_answer: string | null;
}

export interface Question {
  /** Node id, e.g. "2732.134". null in special_question_sections rows. */
  name: string | null;
  text: string;
  /** null = unanswered. string[] = multi-select. */
  answer: Answer;
  /** Default successor when no choice matches. Terminal nodes have null. */
  next_question: string | null;
  /** null ⇒ subjective / free-text question (no enumerated choices). */
  choices: Choice[] | null;
  confidence_score: number;
  facts: {
    supportive: string[];
    contradictory: string[];
    thinking: string;
  };
  user_feedback: UserFeedback[];
}

export interface QuestionSection {
  id: string;
  name: string;
  section_index: number;
  questions: Question[];
}

export interface QuestionOption {
  label: string;
  value: string;
}

export interface QuestionForUI {
  question: string;
  question_type: string;
  show_optional_free_text_for: string[];
  show_mandatory_free_text_for: string[];
  answer: string[] | string;
  free_text_answer: {
    answer: string;
    name: string;
  };
  name: string;
  next_question_name: string;
  options: QuestionOption[];
  shouldShowTextArea: boolean;
  isTextAreaMandatory: boolean;
  evidenceCards?: EvidenceCardConfig[];
  confidenceScore?: number;
  answerChangedReason?: string;
}

export interface CmmMedicalNeccessityQuestionnaireForUI {
  questions: QuestionForUI[];
}

export const QUESTION_TYPE = {
  SUBJECTIVE: "subjective",
  MULTI_SUBJECTIVE: "multi-subjective",
  RADIO_SUBJECTIVE: "radio-subjective",
} as const;

export type QuestionType = (typeof QUESTION_TYPE)[keyof typeof QUESTION_TYPE];

export interface PharmaBranchedQuestionnaire {
  cmm_key?: string;
  updated_at?: string;
  clinical_question_sections?: QuestionSection[];
  special_question_sections?: QuestionSection[];
  medical_details_questions?: Question[];
}

export interface PharmaBranchedQuestionnaireDocument {
  identifier?: string;
  drug_name?: string;
  org_id?: string;
  status?: string;
  created_at?: string;
  cmm_data_snapshot_count?: number;
  cmm_data_latest: PharmaBranchedQuestionnaire;
}
